import { styled } from '@nykaa/ui-components';
import { BASE_WIDGET_PADDING_MOBILE } from 'shared/components/AdPlatformWidgets/constants';
import { DWEB_MAX_WIDTH, BASE_GUTTER_SPACE, COLORS, BREAKPOINTS } from 'shared/styles/base';

export const Wrapper = styled.article`
  width: 100%;
  padding: 0 ${BASE_WIDGET_PADDING_MOBILE}px;

  & a[href] {
    color: ${COLORS.BRAND_PRIMARY_100};
    text-decoration: underline;
    margin: 0 3px;
  }

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    max-width: ${DWEB_MAX_WIDTH}px;
    margin: ${BASE_GUTTER_SPACE}px auto 20px;
  }
`;
